'use client';

import { useMemo } from 'react';
import type { FormConfig, StepConfig } from '../types';
import { flattenSteps, getVisibleSteps } from '../utils/steps';
import type { FormValues } from '../types';

interface UseFormInitializationProps {
  formConfig: FormConfig;
  values: FormValues;
}

interface UseFormInitializationReturn {
  allSteps: StepConfig[];
  stepsById: Record<string, StepConfig>;
  visibleSteps: StepConfig[];
}

/**
 * Hook to initialize and manage form steps
 */
export const useFormInitialization = ({
  formConfig,
  values,
}: UseFormInitializationProps): UseFormInitializationReturn => {
  const allSteps = useMemo(() => flattenSteps(formConfig.steps), [formConfig.steps]);

  const stepsById = useMemo(() => {
    const map: Record<string, StepConfig> = {};
    allSteps.forEach((step) => {
      map[step.id] = step;
    });
    return map;
  }, [allSteps]);

  const visibleSteps = useMemo(() => getVisibleSteps(allSteps, values), [allSteps, values]);

  return {
    allSteps,
    stepsById,
    visibleSteps,
  };
};
